export default __webpack_public_path__ + "images/OK.9d372bc.png";